import { useTranslation } from 'react-i18next';

export const DomesticCovidCoverages = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'covid',
  });

  return {
    title: t('coverage.title'),
    coverages: [
      {
        label: t('postpone.label'),
        remarks: null,
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 5,000',
            remark: null,
            colspan: 3,
          },
        ],
      },
      {
        label: t('cancel.label'),
        remarks: null,
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 5,000',
            remark: null,
            colspan: 3,
          },
        ],
      },
      {
        label: t('medical.label'),
        remarks: null,
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 50,000',
            remark: null,
            colspan: 3,
          },
        ],
      },
      {
        label: t('quarantine.label'),
        remarks: null,
        insuredAmountData: [
          {
            classId: 1,
            amount: '-',
            remark: null,
            colspan: 3,
          },
        ],
      },
      {
        label: t('emergency.label'),
        remarks: null,
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 5,000',
            remark: null,
            colspan: 3,
          },
        ],
      },
      {
        label: t('travel.label'),
        remarks: null,
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 5,000',
            remark: null,
            colspan: 3,
          },
        ],
      },
      {
        label: t('hospital.label'),
        remarks: null,
        insuredAmountData: [
          {
            classId: 1,
            amount: '₱ 5,000',
            remark: null,
            colspan: 3,
          },
        ],
      },
    ],
  };
};

export default DomesticCovidCoverages;
